import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-landing',
  standalone: false,
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {
  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private logger: NGXLogger
  ) {}

  login(): void {
    // Cattura l'URL corrente con tutti i query params per preservarli dopo il login
    // Prima controlla se c'è un URL salvato in sessionStorage (da quando l'utente ha aperto il link)
    // Altrimenti usa l'URL corrente
    const savedUrl = sessionStorage.getItem('pendingRedirectUrl');
    const currentUrl = savedUrl || this.router.url;
    
    // Se ci sono query params, li preserva, altrimenti usa solo /
    const target = currentUrl.includes('?') ? currentUrl : '/';
    
    this.logger.info('[LANDING] Login con target:', target);
    
    // Rimuovi l'URL salvato perché verrà usato ora
    if (savedUrl) {
      sessionStorage.removeItem('pendingRedirectUrl');
    }
    
    this.auth.loginWithRedirect({
      appState: { target: target }
    }).subscribe();
  }
}

